import { format } from "date-fns";
import { useDashboardFilters } from "./dashboard-filters";

export default function useFormattedTimeRange() {
  const { toTimestamp, fromTimestamp } = useDashboardFilters();

  return `${format(fromTimestamp, "MMMM d, yyyy")}${
    toTimestamp ? ` - ${format(toTimestamp, "MMMM d, yyyy")}` : " - Present"
  }`;
}
